import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type Props = {
  settingDefs: any[];
  maxHeight?: number;
};

const SettingDefs = ({ settingDefs = [] }: Props) => {
  return (
    <Box sx={{ overflowY: 'auto' }}>
      <Stack spacing={1.5}>
        {settingDefs
          .filter((section) => !section.system)
          .map((section, idx) => (
            <Box key={idx} sx={{ border: 1, borderColor: 'divider', borderRadius: '8px', overflow: 'hidden' }}>
              <Box sx={{ px: 1.5, py: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Typography variant="caption" sx={{ fontWeight: 700 }}>
                  {section.sectionName}
                </Typography>
              </Box>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%' }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%' }}>
                        Label
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%' }}>
                        Type
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%' }}>
                        Required
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(section.items || []).map((item: any, idx: any) => (
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={idx}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.label}</TableCell>
                        <TableCell>{item.type}</TableCell>
                        <TableCell>{item.required ? 'Yes' : 'No'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ))}
      </Stack>
    </Box>
  );
};

export default SettingDefs;
